import { DeliverabilityRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsDeliverabilityRoute() {
  const { workspaceId } = Route.useParams();
  return <DeliverabilityRoute segment="reports" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/deliverability')({
  component: ReportsDeliverabilityRoute,
});
